import { isNativeAppWebView } from './webview';

/**
 * Select the CDS cookie transport; this marker never authenticates a shopper.
 * Account enablement and rollout remain the caller's responsibility.
 * @param {string} brand - Resolved whitelabel brand.
 * @returns {boolean} Whether this is the web session transport.
 */
export default function isAccountWebTransport(brand) {
  if (brand !== 'cds' || !isNativeAppWebView() || typeof window === 'undefined') return false;
  return /(?:^|\s)reserhub_account_web(?:\s|$)/i.test(window.navigator?.userAgent || '');
}
